module.exports = __webpack_public_path__ + "static/img/system-2.01e668a6.png";